import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
export default function DAvatar({ id, size, image, name: nameProp, useNameAsInitials = false, className, style, dataAttributes, }) {
    const generateClasses = useMemo(() => ({
        'd-avatar': true,
        [`d-avatar-${size}`]: !!size,
    }), [size]);
    const name = useMemo(() => {
        if (!nameProp) {
            return undefined;
        }
        if (useNameAsInitials) {
            return nameProp;
        }
        return nameProp.split(/\s+/).map((word) => word.charAt(0)).join('').toUpperCase();
    }, [nameProp, useNameAsInitials]);
    return (_jsxs("div", Object.assign({ className: classNames(generateClasses, className), style: style, id: id }, dataAttributes, { children: [image && _jsx("img", { src: image, alt: nameProp, className: "d-avatar-img" }), (name && !image) && _jsx("span", { className: "d-avatar-name", children: name })] })));
}
//# sourceMappingURL=DAvatar.js.map